export default __webpack_public_path__ + "static/cotton-6998135c5fe540017067c4e72c526e3c.png";